import { Tabs } from 'expo-router';
import React, { useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import { Colors } from '@/constants/theme';
import {Ionicons} from "@expo/vector-icons";
import FontAwesome from "@expo/vector-icons/FontAwesome";
import { useIsTablet } from '@/hooks/useIsTablet';
import { TabletHeader } from '@/components/TabletHeader';
import { useNotification } from '@/services/notifications/provider';
import { fetchNotifications } from '@/services/universe/client';

export default function TabLayout() {
    const isTablet = useIsTablet();
    const { unreadCount, setUnreadCount, chatUnreadCount } = useNotification();

    useEffect(() => {
        const checkNotifications = async () => {
            try {
                const response = await fetchNotifications();
                if (response.success && typeof response.meta?.unread_count === 'number') {
                    setUnreadCount(response.meta.unread_count);
                }
            } catch (error) {
                console.error("Error fetching initial notification count:", error);
            }
        };

        checkNotifications();
    }, []);

    const content = (
        <Tabs
            screenOptions={{
                tabBarActiveTintColor: Colors.brand,   // active icon/text color
                tabBarInactiveTintColor: '#9CA3AF', // inactive icon/text color
                headerShown: !isTablet,
                tabBarStyle: isTablet ? { display: 'none' } : undefined,
            }}
        >
            <Tabs.Screen
                name="index"
                options={{
                    title: 'Chats',
                    headerShown: false,
                    tabBarIcon: ({ color, focused }) => (
                        <Ionicons name="chatbox-ellipses" size={24} color={color} />
                    ),
                    tabBarBadge: chatUnreadCount > 0 ? chatUnreadCount : undefined,
                    tabBarBadgeStyle: {
                        backgroundColor: '#EF4444',
                        color: 'white',
                        fontSize: 10,
                    },
                }}
            />
            <Tabs.Screen
                name="notifications"
                options={{
                    title: 'Notifications',
                    tabBarIcon: ({ color, focused }) => (
                        <FontAwesome name="bell" size={24} color={color} />
                    ),
                    tabBarBadge: unreadCount > 0 ? unreadCount : undefined,
                    tabBarBadgeStyle: {
                        backgroundColor: '#EF4444',
                        color: 'white',
                        fontSize: 10,
                    },
                }}
            />
            <Tabs.Screen
                name="settings"
                options={{
                    title: 'Settings',
                    tabBarIcon: ({ color, focused }) => (
                        <FontAwesome name="cog" size={24} color={color} />
                    ),
                }}
            />
        </Tabs>
    );

    if (isTablet) {
        return (
            <View style={styles.container}>
                <TabletHeader />
                {content}
            </View>
        );
    }

    return content;
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
